import { injectLocal, provideLocal } from '@vueuse/core';
import { useType as useTypeMCL, useCreateTypeStore } from '@nuxt-common/media-card-large/app/modules/type';
import { usePageData } from '~/composables/usePageData';
import { useProduct } from '~/modules/product/composables/useProduct';
import { useConsolidatedMember } from '~/composables/useConsolidatedMember';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import { useProductType } from '~/composables/useProductType';
import useIsolatedStickyAtbStateStore from '~/modules/sticky-product-traits/stores/useIsolatedStickyAtbStateStore';

/**
 * TO DO: Traits initialization should be moved to the Product level
 * @description
 * This composable is responsible for providing the type data for the Product.
 */
const TYPE_TRAITS_REPOSITORY = 'type-traits';

/**
 * @returns {ReturnType<typeof useTypeMCL>}
 */
export const useType = () => {
  const { productId: id } = useProduct();
  const resultRepository = `${TYPE_TRAITS_REPOSITORY}-${id}`;
  const providedContext = injectLocal(resultRepository, null);

  const { isShopTheSet } = useProductType();
  const { isShopTheSetExpEnabled } = useFeatureEligibility();
  const stickyAtbStore = useIsolatedStickyAtbStateStore();

  if (providedContext) {
    return providedContext;
  }
  if (isShopTheSetExpEnabled && isShopTheSet) {
    const { typeLabel, selectedTypeId, selectedType, types } = useConsolidatedMember();
    return {
      label: typeLabel,
      selectedTypeId,
      selectedType,
      types,
    };
  }

  useCreateTypeStore({ id, data: usePageData().traits.type[id] ?? stickyAtbStore.pageDataStickyAtbTraits?.type?.[id] });

  const context = useTypeMCL(id);
  provideLocal(resultRepository, context);

  return context;
};
